import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faStar } from '@fortawesome/free-solid-svg-icons';
import EditNamePopup from '../../EditPopup/Editnamepopup';
import { updateFirstName, updateLastName } from '../../../api/axios'; // Import your API functions

const ProfileHeader = ({ userDetails }) => {
  const registerResult = userDetails?.registerResult || {};
  const role = registerResult.role || 'Unknown';

  // State to manage the first and last names
  const [firstName, setFirstName] = useState(
    registerResult.firstName || 'First Name'
  );
  const [lastName, setLastName] = useState(
    registerResult.lastName || 'Last Name'
  );
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleEditClick = () => {
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
  };

  const handleSave = async (newFirstName, newLastName) => {
    try {
      await updateFirstName(registerResult.id, newFirstName);
      await updateLastName(registerResult.id, newLastName);

      // Update the state to reflect the changes
      setFirstName(newFirstName);
      setLastName(newLastName);
    } catch (error) {
      console.error('Failed to update names:', error);
    }
  };

  return (
    <>
      <div className='' style={{ display: 'flex', flexDirection: 'column', alignItems: 'start',float: 'left', width: '100%' }}>
        <div className='log-profile-header'>
          <span className='log-profile-user-name'>{firstName}</span>
          <span className='log-profile-user-name'>{lastName}</span>
          <FontAwesomeIcon
            icon={faEdit}
            className='log-profile-edit-icon'
            style={{ color: '#6E0506' }}
            onClick={handleEditClick}
          />
          {role === 'actor' && (
            <div>
              <FontAwesomeIcon
                icon={faStar}
                className='star'
                style={{ color: '#6E0506' }}
              />
              <span className='profile-score'>
                {registerResult?.rate || userDetails?.result?.rate || 0}
              </span>
            </div>
          )}

          <EditNamePopup
            isOpen={isPopupOpen}
            onClose={handlePopupClose}
            currentFirstName={firstName}
            currentLastName={lastName}
            onSave={handleSave}
          />
        </div>
        <div className='flex'>
          <h6 style={{fontWeight:'600',textTransform:'capitalize'}}>Role : {role=='director'?'Casting Director':role}</h6>
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;
